import { useMutation } from '@tanstack/react-query';

export function useCreateCompanySwitchMutation() {
  return useMutation({
    mutationFn: async ({ companyId }) => {
      const response = await axios.post('/company_switches', {
        company_switch: { company_id: companyId },
      });
      return response.data;
    },
  });
}
